// frontend/src/components/ServiceType/ServiceTypeListMobile.tsx
// Mobile-optimized list component

import React from 'react';
import { ServiceType } from '@/lib/api/serviceTypeService';
import ServiceTypeCard from './ServiceTypeCard';

interface ServiceTypeListMobileProps {
  serviceTypes: ServiceType[];
  onEdit: (serviceType: ServiceType) => void;
  onDelete: (id: number, name: string) => void;
  onToggleStatus: (id: number) => void;
  onApprove?: (id: number) => void;
  onReject?: (id: number) => void;
}

const ServiceTypeListMobile: React.FC<ServiceTypeListMobileProps> = ({
  serviceTypes = [],
  onEdit,
  onDelete,
  onToggleStatus,
  onApprove,
  onReject
}) => {
  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      {/* Service type cards */}
      <div className="divide-y divide-gray-200">
        {serviceTypes.map((serviceType) => (
          <ServiceTypeCard
            key={serviceType.service_type_id}
            serviceType={serviceType}
            onEdit={() => onEdit(serviceType)}
            onDelete={() => onDelete(serviceType.service_type_id, serviceType.name)}
            onToggleStatus={() => onToggleStatus(serviceType.service_type_id)}
            onApprove={onApprove ? () => onApprove(serviceType.service_type_id) : undefined}
            onReject={onReject ? () => onReject(serviceType.service_type_id) : undefined}
          />
        ))}
      </div>
    </div>
  );
};

export default ServiceTypeListMobile;
